export class UserDetails {
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    accessLevel: string
}